module.exports = "/images/Icon industry-Bowling.svg?a72ef06fa73d8b36e2d7c8a7e1522600";